// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"187":"e24ee782140a4af711f5","245":"d0f6648efd8c76dc9e29","428":"6babf80a46797439da34","975":"d94e43f8eb409441d35c"}[chunkId] + ".min.js";
};